import { useTheme } from '@mui/material';

export const WalletIcon = () => {
    const theme = useTheme();

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14 5.33333V12.6667C14 12.8435 13.9298 13.013 13.8047 13.1381C13.6797 13.2631 13.5101 13.3333 13.3333 13.3333H2.66667C2.48986 13.3333 2.32029 13.2631 2.19526 13.1381C2.07024 13.013 2 12.8435 2 12.6667V4C2 4.35362 2.14048 4.69276 2.39052 4.94281C2.64057 5.19286 2.97971 5.33333 3.33333 5.33333H14ZM3.33333 2.66666C2.97971 2.66666 2.64057 2.80714 2.39052 3.05719C2.14048 3.30724 2 3.64638 2 4C2 4.35362 2.14048 4.69276 2.39052 4.94281C2.64057 5.19286 2.97971 5.33333 3.33333 5.33333H12.6667V2.66666H3.33333ZM14 10.6667H10.6667C10.4899 10.6667 10.3203 10.5964 10.1953 10.4714C10.0702 10.3464 10 10.1768 10 10V8.66666C10 8.48985 10.0702 8.32028 10.1953 8.19526C10.3203 8.07024 10.4899 8 10.6667 8H14V10.6667Z"
                stroke={theme.palette.text.primary}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
